export const generateCsv = (body: string): string => {
    const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
    const blob = new Blob([bom, body], { type: 'text/csv' });
    return window.URL.createObjectURL(blob);
};

export const removeCsvUrl = (csvUrl: string): void => window.URL.revokeObjectURL(csvUrl);
